import { occurrenceSchema, type Occurrence } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const fetchOccurrence = (id: string, signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>(`/occurrences/${id}`, { signal });

export const getOccurrence = async (id: string, signal: AbortSignal): Promise<Occurrence> =>
  occurrenceSchema.parse(await fetchOccurrence(id, signal));
